import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import * as promoCodesActions from './../promoCodes.actions';
import * as activityConstants from '../../Activity/activity.constants';
import * as activityActions from '../../Activity/activity.actions';

const REFRESH_INTERVAL_IN_SEC = 5;

class PromoCodeBulkListItem extends Component {

  state = {
    isLoading: false,
    intervalId: null
  };

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  getBulkExport = () => {
    this.initializeInterval();
  };

  initializeInterval() {
    const { bulk } = this.props;
    this.setState({ isLoading: true });
    this.getBulkExportUrl();
    if (bulk.get(activityConstants.PROMO_CODE_BULK_EXPORT_DATA_FILE) === undefined) {
      this.setState({ intervalId: setInterval(this.getBulkExportUrl, REFRESH_INTERVAL_IN_SEC * 1000) });
    }
  }

  getBulkExportUrl = () => {
    const { bulk, serverId, promoCode } = this.props;
    const bulkExportDataFile = bulk.get(activityConstants.PROMO_CODE_BULK_EXPORT_DATA_FILE);
    if (bulkExportDataFile !== undefined) {
      clearInterval(this.state.intervalId);
      this.props.actions.getBulkSignedUrl(
        bulkExportDataFile.get(activityConstants.PROMO_CODES_EXPORT_BULK_OBJECT_NAME),
        bulkExportDataFile.get(activityConstants.PROMO_CODES_EXPORT_BULK_BUCKET_NAME));
      this.setState({ isLoading: false });
    } else {
      const bulkKey = bulk.get(activityConstants.KEY);
      const taskId = bulk.get(activityConstants.PROMO_CODES_EXPORT_BULK_TASK_ID);
      this.props.actions.getBulkExportDataFile(bulkKey, serverId, taskId, promoCode);
    }
  }

  render() {
    const { bulk, index, serverId, intl, status } = this.props;
    const isTest = bulk.get('isTest');
    const bulkName = isTest ? intl.formatMessage({ id: 'promoCode.testBulk.name' }) : bulk.get('name');

    return (
      <li className="promo-bulk-data">
        <div className="bulk-name">{`${index + 1}. ${bulkName}`}</div>
        <div className="bulk-size">{bulk.get('size')}</div>
        <div className="bulk-controls">
          <div className="svg-icon-container">

            { isTest ?
              <Icon className="como-ic-view no-padding" onClick={() => { this.props.actions.getBulkList(bulk.get('key'), serverId); }} />
              :
              (this.state.isLoading ?
                <Loader active inline size="small" />
                :
                <Icon className="como-ic-export no-padding" onClick={this.getBulkExport} />
              )
            }

          </div>
        </div>
        <div className="bulk-status">{status === activityConstants.ACTIVITY_STATUS_STOPPED || status === activityConstants.ACTIVITY_STATUS_INACTIVE ? intl.formatMessage({ id: 'activity.actions.benefits.inactive' }) : ''}</div>
      </li>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...promoCodesActions, ...activityActions }, dispatch)
  };
}

const withConnect = connect(null, mapDispatchToProps);

PromoCodeBulkListItem.propTypes = {
  bulk: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  actions: PropTypes.object,
  serverId: PropTypes.string,
  status: PropTypes.string,
  intl: PropTypes.object,
  promoCode: PropTypes.object
};

export default compose(withConnect, injectIntl)(PromoCodeBulkListItem);
